/** @format */
'use strict';

// Breakpoint definitions aligned with the SCSS setup
const BP_MOBILE = 550
const BP_TABLET = 800
const BP_DESKTOP = 1000
const BP_WIDE = 1200
const BP_SUPER_WIDE = 1500

/*
* Masthead Videos - handles video controls, loop setting and load appropriate video depending on current screen size
*/

let resizeTimer;
const motionQuery = matchMedia('(prefers-reduced-motion)');
const msthVideoDesktop = document.querySelector('#c-masthead__video--desktop');
const msthVideoMobile = document.querySelector('#c-masthead__video--mobile');
const msthVideoDesktopControl = document.querySelector('#c-masthead__video-control--desktop');
const msthVideoMobileControl = document.querySelector('#c-masthead__video-control--mobile')
const msthVideoControls = document.querySelectorAll('.c-masthead__video-control');

// Lazy loading videos depending current screen size
if (window.innerWidth < BP_TABLET && msthVideoMobile) {
    loadVideo(msthVideoMobile, msthVideoMobileControl)
} else {
    loadVideo(msthVideoDesktop, msthVideoDesktopControl)
}

window.onresize = function() {
    const screenWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        if (screenWidth >= BP_TABLET) {
            loadVideo(msthVideoDesktop, msthVideoDesktopControl)
        } else {
            loadVideo(msthVideoMobile, msthVideoMobileControl)
        }
    }, 150);
}

// Reduced motion checks - pausing all video if reduced motion setting active
motionQuery.addEventListener('change', function(e) {
    if (motionQuery.matches) {
        if(msthVideoDesktop) {
            pauseVideo(msthVideoDesktop, msthVideoDesktopControl);
        }

        if(msthVideoMobile) {
            pauseVideo(msthVideoMobile, msthVideoMobileControl);
        }
    }
});

// Masthead video play/pause
if (msthVideoControls) {
    msthVideoControls.forEach(control => {
        control.addEventListener('click', (e) => {
            const video = document.querySelector(control.dataset.target);
            if (video.paused) {
                playVideo(video, control);
            } else {
                pauseVideo(video, control)
            }
        })
    });
}

// Masthead video looping - allows for videos to be loop after a delay
const videosWithTimedLoop = document.querySelectorAll('video[data-timed-loop]');
if (videosWithTimedLoop.length > 0) {
    videosWithTimedLoop.forEach(video => {
        const loopAfter = video.dataset.timedLoop;

        video.addEventListener('ended', (e) => {
            setTimeout(function(){
                e.target.play();
            }, loopAfter);
        });
    });
}

/**
 * Triggers video to play and updates video control
 * @param {Element} video
 * @param {Element} control
 */
function playVideo(video, control){
    video.play();
    control.setAttribute('aria-pressed', false);
    control.querySelector('span').textContent = 'Pause';
    control.querySelector('.c-masthead__video-control-icon').classList.remove('fa-play');
    control.querySelector('.c-masthead__video-control-icon').classList.add('fa-pause');
}

/**
 * Triggers video to pause and updates video control
 * @param {Element} video
 * @param {Element} control
 */
function pauseVideo(video, control){
    video.pause();
    control.setAttribute('aria-pressed', true);
    control.querySelector('span').textContent = 'Play';
    control.querySelector('.c-masthead__video-control-icon').classList.remove('fa-pause');
    control.querySelector('.c-masthead__video-control-icon').classList.add('fa-play');
}

/**
 * Loads and plays video
 * @param {Element} video
 * @param {Element} control
 */
function loadVideo(video, control) {
    if (video) {
        video.load();
        if (motionQuery.matches) {
            pauseVideo(video, control)
        } else {
            playVideo(video, control)
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/masthead.js